import { render, staticRenderFns } from "./purchaseReturnedProductRecords.vue?vue&type=template&id=78e10d1f&scoped=true"
import script from "./purchaseReturnedProductRecords.vue?vue&type=script&lang=js"
export * from "./purchaseReturnedProductRecords.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnedProductRecords.vue?vue&type=style&index=0&id=78e10d1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e10d1f",
  null
  
)

export default component.exports